import { tones } from '../tone.constant';

export const triageBriefingTexts = {
    title: 'Triagem',
    updatedAt: 'Atualizado em',
    itemSeparator: ' · ',
    openSource: 'Abrir fonte',
    showMore: 'ver mais',
    showLess: 'ver menos',
};

export const triageBriefingReferenceTexts = {
    title: 'Referências da pesquisa',
    openPage: 'Abrir página',
    noneUsed: 'Nenhum resultado foi ligado à pessoa.',
    analyzed: (total) => (total === 1 ? '1 resultado analisado' : `${total} resultados analisados`),
};

export const triageBriefingUses = {
    who: 'quem',
    arrival: 'chegada',
    history: 'historico',
    sizing: 'dimensao',
};

export const triageBriefingUseTitles = {
    [triageBriefingUses.who]: 'Quem é',
    [triageBriefingUses.arrival]: 'Como chegou',
    [triageBriefingUses.history]: 'Histórico com a Facilita',
    [triageBriefingUses.sizing]: 'Para dimensionar a oferta',
};

export const triageBriefingProfiles = {
    anonimo: { label: 'Sem cadastro', tone: tones.neutral },
    lead: { label: 'Lead', tone: tones.blue },
    cliente_novo: { label: 'Cliente novo', tone: tones.emerald },
    cliente_ativo: { label: 'Cliente ativo', tone: tones.violet },
    cliente_parado: { label: 'Cliente parado', tone: tones.orange },
};

export const triageBriefingProseKeys = ['desdeQueParou'];

export const triageBriefingReadingTexts = {
    title: 'Análise',
    staleNote: 'Escrita antes da última atualização do cartão: confira os fatos abaixo',
    researchNote: 'Escrita antes da pesquisa externa, que está a caminho: a leitura é refeita quando ela chegar',
};

export const triageBriefingReadingKey = 'analise';

export const triageBriefingAnalysisParts = [
    { key: 'profissional', title: 'Quem é' },
    { key: 'relacao', title: 'Relação com a Facilita' },
    { key: 'conversa', title: 'Para a conversa', leadsWithRecommendation: true },
];

export const triageBriefingHiddenFactKeys = ['respostaDeConfianca', 'respostaDeRegra'];

export const TRIAGE_BRIEFING_HEADLINE_LINES = 3;

export const DRAWER_CONTENT_DELAY_MS = 220;

export const TRIAGE_BRIEFING_OPEN_EVENT = 'triagem_cartao_aberto';

export const TRIAGE_BRIEFING_FEEDBACK_EVENT = 'triagem_cartao_avaliado';

export const triageBriefingFeedbackTexts = {
    question: 'Esta triagem ajudou?',
    useful: 'Útil',
    notUseful: 'Não ajudou',
    thanks: 'Obrigado',
};

export const triageBriefingSurfaces = {
    detail: 'detalhe',
    message: 'mensagem',
    call: 'ligacao',
};
